// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"sq-z","slideIn":"tq-z"};